// src/layout/AppLayout.tsx
import React,{useState,useEffect} from 'react';

import { useNavigate} from 'react-router-dom';
import { Layout} from 'antd';
import Sidebar from './Sidebar';
import HeaderComponent from './Header';
import { Outlet } from 'react-router-dom';
import { customThemes } from '../themes/themeConfig'
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../redux/slice/userSlice';


import useAutoLogout from '../hooks/useAutoLogout';
const { Content, Footer } = Layout;

const AppLayout = () => {
      // use auto logout after 5 min
      const dispatch = useDispatch();
      const navigate = useNavigate();

      const handleLogout = () => {
        dispatch(logout());
        navigate('/login');
      };

      useAutoLogout(handleLogout, 50);


      const [collapsed, setCollapsed] = useState(false);
      const [darkMode, setDarkMode] = useState(false);

      const themeStyles = darkMode ? customThemes.dark : customThemes.light;

      const useMediaQuery = (query: string) => {
        const [matches, setMatches] = useState(false);
        useEffect(() => {
          const media = window.matchMedia(query);
          setMatches(media.matches);
          const listener = () => setMatches(media.matches);
          media.addEventListener('change', listener);
          return () => media.removeEventListener('change', listener);
        }, [query]);
    
        return matches;
      };
      const isMobile = useMediaQuery('(max-width: 768px)');
      useEffect(() => {
        if (isMobile) {
          setCollapsed(true);
        }
      }, [isMobile]);
  return (
    

    <Layout style={{ minHeight: '100vh' }}>
      <Sidebar
      collapsed={collapsed}
      darkMode={darkMode}
      themeStyles={themeStyles}
      isMobile={isMobile}
      />
      <Layout>
        <HeaderComponent 
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          darkMode={darkMode}
          setDarkMode={setDarkMode}
          themeStyles={themeStyles}
          isMobile={isMobile}
        />
        <Content
        style={{ padding: '16px', minHeight: 360, backgroundColor: themeStyles.contentBg, color: themeStyles.contentText, }}>
          <Outlet context={{ darkMode, themeStyles }}  /> {/* Render the nested route components here */}
        </Content>
        <Footer style={{ textAlign: 'center', padding:'16px 0',backgroundColor: themeStyles.footerBg, color: themeStyles.contentText }}>
          CRM ©{new Date().getFullYear()}
        </Footer>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
